// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"a459c8c1","86":"9c0aa1d0","117":"56a643fb","453":"4ea7954b","519":"51ddd264","522":"d7507b55"}[chunkId] + ".chunk.js";
};